declare global {
  const CKEDITOR: any;
  const Smartlink: any;
}

const documentEditorConfig: { [k: string]: any } = {
  plugins: [
    CKEDITOR.Autoformat,
    CKEDITOR.Bold,
    CKEDITOR.Italic,
    CKEDITOR.Underline,
    CKEDITOR.Subscript,
    CKEDITOR.Superscript,
    CKEDITOR.Strikethrough,
    CKEDITOR.BlockQuote,
    CKEDITOR.CodeBlock,
    CKEDITOR.Essentials,
    CKEDITOR.FindAndReplace,
    CKEDITOR.FontColor,
    CKEDITOR.FontSize,
    CKEDITOR.FontBackgroundColor,
    CKEDITOR.Alignment,
    CKEDITOR.Heading,
    CKEDITOR.HorizontalLine,
    CKEDITOR.RemoveFormat,
    CKEDITOR.SpecialCharacters,
    CKEDITOR.SpecialCharactersArrows,
    CKEDITOR.SpecialCharactersCurrency,
    CKEDITOR.SpecialCharactersEssentials,
    CKEDITOR.SpecialCharactersLatin,
    CKEDITOR.SpecialCharactersMathematical,
    CKEDITOR.SpecialCharactersText,
    CKEDITOR.Image,
    CKEDITOR.ImageCaption,
    CKEDITOR.ImageStyle,
    CKEDITOR.ImageToolbar,
    CKEDITOR.ImageUpload,
    CKEDITOR.Indent,
    CKEDITOR.Link,
    CKEDITOR.List,
    CKEDITOR.MediaEmbed,
    CKEDITOR.Paragraph,
    CKEDITOR.PasteFromOffice,
    CKEDITOR.Table,
    CKEDITOR.TableToolbar,
  ],

  toolbar: {
    shouldNotGroupWhenFull: false,
    items: [
      "undo",
      "redo",
      "|",
      "bold",
      "italic",
      "underline",
      "fontSize",
      "fontColor",
      "|",
      "link",
      "findAndReplace",
      "|",
      "alignment",
      "|",
      "bulletedList",
      "numberedList",
      "|",
      "outdent",
      "indent",
      "|",
      "insertTable",
      "specialCharacters",
      "subscript",
      "superscript",
      "|",
      "codeBlock",
      "blockQuote",
      "|",
      "fontBackgroundColor",
      "strikethrough",
      "|",
      "horizontalLine",
      "|",
      "removeFormat",
    ],
  },
  table: {
    contentToolbar: [
      "tableColumn",
      "tableRow",
      "mergeTableCells",
      "toggleTableCaption",
      "tableProperties",
      "tableCellProperties",
    ],
  },
  image: {
    toolbar: [
      "toggleImageCaption",
      "linkImage",
      "imageTextAlternative",
      "|",
      "imageStyle:alignLeft",
      "imageStyle:alignRight",
      "imageStyle:alignBlockLeft",
      "imageStyle:alignBlockRight",
      "imageStyle:alignCenter",
    ],
  },
  licenseKey: import.meta.env.VITE_CKE_PREMIUM_FEATURES_LICENSE_KEY,
  indentBlock: {
    offset: 2,
    unit: "em",
  },
  fontSize: {
    options: [
      {
        title: "Small",
        model: "12px",
        upcastAlso: [],
        view: "",
      },
      {
        title: "Normal",
        model: "13px",
        upcastAlso: [],
        view: "",
      },
      {
        title: "Large",
        model: "19.6px",
        upcastAlso: [],
        view: "",
      },
    ],
  },
};

export const getDocumentEditorConfig = (companyId: number) => {
  const config = { ...documentEditorConfig };
  if ((window as any).Smartlink && (window as any).Smartlink.QualioSmartlink) {
    config.plugins = [
      ...config.plugins,
      CKEDITOR.Mention,
      Smartlink.QualioSmartlink,
    ];
    config.mention = Smartlink.QualioSmartlink.getMentionConfig(
      companyId,
      import.meta.env.VITE_GLOBAL_SEARCH_SERVICE_HOSTNAME,
    );
  }

  return config;
};
